"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var UIDialogBody = (0, _react.forwardRef)(function (_ref, ref) {
  var className = _ref.className,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["className"]);
  return _react.default.createElement("div", Object.assign({
    ref: ref
  }, rest, {
    className: (0, _classnames.default)("uiDialogBody private-modal__body has--vertical-spacing", className)
  }));
});
UIDialogBody.propTypes = {
  children: _propTypes.default.node
};
UIDialogBody.displayName = 'UIDialogBody';
var _default = UIDialogBody;
exports.default = _default;
module.exports = exports.default;